var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8973 0C16.0804 0.0271461 10.5109 2.35698 6.40731 6.47984C2.30369 10.6027 -6.33399e-05 16.183 1.30613e-09 22C1.30614e-09 27.8348 2.31785 33.4305 6.44365 37.5564C10.5695 41.6821 16.1652 44 22 44C27.8348 44 33.4305 41.6821 37.5564 37.5564C41.6821 33.4305 44 27.8348 44 22C44 16.1652 41.6821 10.5695 37.5564 6.44365C33.4305 2.31785 27.8348 0 22 0L21.8973 0ZM30.9943 13.244C31.1777 13.2403 31.5828 13.2862 31.8468 13.5007C32.0231 13.6523 32.1352 13.8653 32.1603 14.0965C32.1897 14.267 32.2263 14.6575 32.197 14.9618C31.867 18.4415 30.4333 26.8822 29.7037 30.778C29.3957 32.428 28.7888 32.9798 28.2003 33.033C26.9243 33.1522 25.9545 32.1897 24.717 31.3793C22.781 30.1088 21.6865 29.3187 19.8073 28.0793C17.6348 26.6493 19.0428 25.861 20.2803 24.5777C20.6048 24.2403 26.2332 19.1198 26.3432 18.656C26.356 18.5973 26.3688 18.381 26.2405 18.2673C26.1122 18.1537 25.9215 18.1922 25.784 18.2233C25.5897 18.2686 22.4968 20.3127 16.5055 24.3558C15.6255 24.9608 14.8298 25.2542 14.1185 25.2358C13.3338 25.2212 11.8232 24.794 10.6993 24.4292C9.32067 23.98 8.22617 23.7435 8.3215 22.9827C8.37039 22.5867 8.91611 22.1815 9.95867 21.7672C16.3717 18.9732 20.6482 17.1313 22.7883 16.2415C28.897 13.7005 30.1675 13.2587 30.9943 13.244Z",
    fill: "#9C9D9F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcons);
export default __webpack_public_path__ + "static/media/telegram-icons.ba63d0d623f75de18308208a84e55aea.svg";
export { ForwardRef as ReactComponent };